import { render, staticRenderFns } from "./HomeRowProducts.vue?vue&type=template&id=0b244396&"
import script from "./HomeRowProducts.vue?vue&type=script&lang=js&"
export * from "./HomeRowProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeRowProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports